import type { FunctionComponent } from 'react';

import { BreakPoints } from '@kanda-libs/ks-design-library';

import DesktopBacs from './Desktop';
import MobileBacs from './Mobile';
import usePayByBacsProps from './usePayByBacsProps';

const PayByBacs: FunctionComponent = function () {
  const props = usePayByBacsProps();
  return (
    <BreakPoints
      mobile={<MobileBacs {...props} />}
      desktop={<DesktopBacs {...props} />}
    />
  );
};
export default PayByBacs;
